import common from './common.js'
export default {
  ...common
}



// WEBPACK FOOTER //
// ./src/filters/index.js